<template>
  <div class="getting_ready">
    <p>Getting ready for a meeting…</p>

    <button class="color_btn hover_op" @click="join">Join now</button>
  </div>
</template>

<script>
export default {
  name: "joinCall",

  methods: {
    async join() {
      console.log("joinCall.vue join()");
      const { access } = await this.$store.dispatch("join");

      if (access.level !== "full") {
        await this.$store.dispatch("requestAccess", "full");
      }
    },
  },
};
</script>

<style>
</style>
